import * as React from 'react';
import classNames from 'classnames';
import { ListItem, ButtonBase } from '@material-ui/core';
import PropTypes from 'prop-types';

import ImageThumbnail from './ImageThumbnail';
import { SERVER_IP } from '../../../../Util/Config';
import TextTruncate from 'react-text-truncate';
import Cookies from 'js-cookie';

const propTypes = {
  epg: PropTypes.shape({
    _id: PropTypes.string,
    channel: PropTypes.string,
    start: PropTypes.string,
    title: PropTypes.string,
    summary: PropTypes.string,
    timeShift: PropTypes.string,
  }),
  channel: PropTypes.shape({
    _id: PropTypes.number,
    ch: PropTypes.string,
    epg: PropTypes.string,
    ext: PropTypes.string,
    ext_thumbnail: PropTypes.string,
    group: PropTypes.string,
    logo: PropTypes.string,
    number: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
};

const defaultProps = {
  epg: {
    _id: '',
    channel: '',
    start: '',
    title: '',
    summary: '',
    timeShift: '',
  },
  channel: null,
};

const EVENT_EPGCLICK = 'epg.click';

const toBackgroundImage = (ch, timeShift) =>
  `${SERVER_IP}/cli/thumb/${ch}?time=${timeShift}`;

class EpgListItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      select: false,
    };
    this.getToken = this.getToken.bind(this);
    this.handerEpgClick = this.handerEpgClick.bind(this);
    this.handerClick = this.handerClick.bind(this);
    this.handlerThumbnailClick = this.handlerThumbnailClick.bind(this);
    this.drawContents = this.drawContents.bind(this);
    this.drawThumbnail = this.drawThumbnail.bind(this);
  }
  componentDidMount() {
    document.addEventListener(EVENT_EPGCLICK, this.handerEpgClick);
  }

  componentWillUnmount() {
    document.removeEventListener(EVENT_EPGCLICK, this.handerEpgClick);
  }

  getToken() {
    const cookie = Cookies.get('TIME_AUTH');
    if (!cookie || !cookie.replace) {
      return cookie
    }
    const re = /"/gi;
    const token = encodeURIComponent(cookie.replace(re, "'"));
    return token;
  }

  handerEpgClick({ detail }) {
    if (detail._id === this.props.epg._id) {
      this.setState({ select: true });
    } else if (this.state.select) {
      this.setState({ select: false });
    }
  }

  handerClick() {
    if (!this.state.select) {
      const event = new CustomEvent(EVENT_EPGCLICK, {
        detail: { _id: this.props.epg._id },
      });
      document.dispatchEvent(event);
    }
  }

  handlerThumbnailClick() {
    const { channel, epg } = this.props;
    const { timeShift } = epg;
    const imagURL = toBackgroundImage(channel.ch, timeShift);
    const cookie = this.getToken();
    const detail = {
      ...this.props.epg,
      thumbnail: `${imagURL}&token=${cookie}`,
      ch: channel,
      videoURL: `${channel.url}/${channel.ch}/index-${timeShift}.m3u8`,
    };
    const event = new window.CustomEvent('dvr.click', { detail });
    document.dispatchEvent(event);
  }

  drawThumbnail() {
    const { channel, epg } = this.props;
    const bg = toBackgroundImage(channel.ch, epg.timeShift);
    const cookie = this.getToken();
    return (
      <ImageThumbnail
        onClick={this.handlerThumbnailClick}
        backgroundImage={`${bg}&token=${cookie}`}
      />
    );
  }

  drawContents() {
    const { title, summary } = this.props.epg;

    return (
      <div className="contents-body" onClick={this.handlerThumbnailClick}>
        <div className="contents-container">
          <div className="contents-body-title">{title}</div>
          <div className="contents-body-summary-container">
            <TextTruncate
              line={2}
              containerClassName="contents-body-summary"
              truncateText="…"
              text={summary}
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { select } = this.state;

    return (
      <ListItem
        button={!select}
        classes={{
          root: classNames('epg-list--li', { select }),
        }}
        onClick={this.handerClick}
      >
        <div className="date">{this.props.epg.start}</div>
        {select && this.drawThumbnail()}
        {!select && (
          <div className="title">
            <div>{this.props.epg.title}</div>
          </div>
        )}
        {select && this.drawContents()}
        {select && (
          <ButtonBase
            classes={{ root: 'epg-item--video-play' }}
            onClick={this.handlerThumbnailClick}
          />
        )}
      </ListItem>
    );
  }
}

EpgListItem.propTypes = propTypes;
EpgListItem.defaultProps = defaultProps;

export default EpgListItem;
